import React, { useState } from 'react'
import classes from './DeletePopup.module.scss';
import CustomHeader from '../custom-header/CustomHeader';
import Button from 'shared/components/form-input/button/Button';
import useTrans from 'hooks/use-trans';
import CustomHeaderConfirm from '../custom-header/CustomHeaderConfirm';

function DeletePopup(props) {
    const { showVisible, payload } = props;
    const [loading, setLoading] = useState(false)
    const { t } = useTrans();

    const handleAccept = () => {

        if (!payload?.isLoading) {
            payload?.callback && payload?.callback();
            showVisible(false);
        } else {
            setLoading(true);
            payload?.callback && payload?.callback({
                hiddenPopup: () => {
                    showVisible(false);
                    setLoading(false)
                }
            });
        }
    }
    return (
        <>
            <div className={classes['DeletePopup']}>
                <CustomHeaderConfirm showVisible={showVisible} payload={payload} />
                <div className={classes['Body']}>
                    <p>{payload?.title ?? t("E0044")}</p>
                    <div className={classes['Footer']}>
                        <Button loading={loading} onClick={handleAccept} title={t("confirm_popup.yes")} />
                        <Button disabled={loading} onClick={() => showVisible(false)} color='gray' title={t("confirm_popup.no")} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default DeletePopup